import { config } from '../config';
import { getHeaders } from './getHeaders';

export const getImage = async (token: string, imageId: string) =>
  fetch(`${config.classificationUrl}/api/v1/image/${imageId}`, {
    method: 'GET',
    headers: getHeaders(token),
  });
